export default {
  default: {
    pdv: {
      taille: 58,
    },
    pdvConcurent: {
      taille: 46,
    }
  }
}
